import { ALL_ALLOWED_TYPES, FILES_ALLOWED_TYPES, IMAGES_ALLOWED_TYPES, MEDIA_ALLOWED_TYPES } from "./constants";

/** Exported so consumers rendering a cap as "N MB" divide by the same factor the caps are built from. */
export const BYTES_PER_MB = 1024 * 1024;

export const Config = {
  STORY_POST_MEDIA_ALLOWED_CONFIG: {
    extensions: MEDIA_ALLOWED_TYPES,
    maxFiles: 20,
  },
  STORY_POST_FILE_ALLOWED_CONFIG: {
    extensions: FILES_ALLOWED_TYPES,
    maxFiles: 1,
  },
  SCHOOL_ID_BADGE_ALLOWED_CONFIG: {
    extensions: [".pdf", ...IMAGES_ALLOWED_TYPES],
    maxFiles: 1,
  },
  STUDENT_ROSTER_ALLOWED_CONFIG: {
    extensions: IMAGES_ALLOWED_TYPES,
    maxFiles: 1,
  },
  ANNOUNCEMENT_ALLOWED_CONFIG: {
    extensions: ALL_ALLOWED_TYPES,
    maxFiles: 10,
    // A reasonableness check, not a technical bound.
    maxFilenameLength: 125,
    maxFileSizeBytes: 500 * BYTES_PER_MB,
  },
  CLASS_STUDENT_AVATAR_SET_ALLOWED_CONFIG: {
    extensions: IMAGES_ALLOWED_TYPES,
    maxFiles: 10,
  },
};
